<template>
  <loader/>
</template>

<script>
import Loader from '@/components/Loader.vue'
import CounselorClient from '../../api/CounselorClient';
export default {
  name: 'ThirdPartyLinkComplete',
  components: {
    Loader,
  },
  data() {
    return {
      counselorClient: new CounselorClient(this.$http),
      redirectUri: document.location.origin + document.location.pathname,

    }
  },
  async mounted() {
    const { state, code } = this.$route.query;
    if(!state || !code) {
      this.$router.push({ name: 'availability' });
      return;
    }
    try {
      const counselorId = Number(state);
      await this.counselorClient.linkThirdPartyCalendar(counselorId, code, this.redirectUri);

      this.$store.commit('setGlobalAlert', {
        msg: 'Calendar linked successfully!',
      });
    } catch (ex) {
      console.error(ex);
      this.$store.commit('setGlobalAlert', {
        msg: 'Failed linking to third party calendar. Please try again. If the issue persists, please contact support.', 
        error: true,
      });
    } finally {
      this.$router.push({ name: 'availability' });
    }
  }
}
</script>

<style>

</style>